<template>
  <ModalPlayerLayout :closeModal="closeSettingsModal" customClass="body modalLayout">
    <template v-slot:default>
      <div class="vjs-settings-menu">
        <div v-if="getSkinInfos.info_empreinte" class="vjs-menu-content">
          <InfoSection />
        </div>
        <div 
        
        v-if="getSkinInfos.control_quality"
         class="vjs-menu-content" :class="{ 'keys-shown': !isKeysShow, 'keys-hidden': isKeysShow }" >
          <QualitySelection :player="player" :currentQualityIndex="currentQualityIndex"
            :closeModal="closeSettingsModal" />
        </div>

        <div 
         v-if="getSkinInfos.control_speed"
        class="vjs-menu-content" :class="{ 'keys-shown': !isKeysShow, 'keys-hidden': isKeysShow }">
          <RateSection :player="player" :currentRateIndex="currentRateIndex" :closeModal="closeSettingsModal" />
        </div>
        <div v-if="getSkinInfos.info_shortcuts" class="vjs-menu-content">
          <ShortcutSection v-on:click="handleKeysDisplay()" :isKeysShow="isKeysShow" :isDvr="player.options_.isDvr" :isLive="isLive"/>
        </div>
      </div>
    </template>
  </ModalPlayerLayout>
</template>

<script >
import { defineComponent } from "vue";
import ModalPlayerLayout from "../../layout/ModalPlayerLayout/ModalPlayerLayout.vue";
import QualitySelection from "./Sections/QualitySelection/QualitySelection.vue";
import RateSection from "./Sections/RateSection/RateSection.vue";
import InfoSection from "./Sections/InfoSection/InfoSection.vue";
import { mapGetters } from "vuex";

import ShortcutSection from "./Sections/ShortcutSection/ShortcutSection.vue";

export default defineComponent({
  name: "SettingsModal",
  components: {
    ModalPlayerLayout,
    QualitySelection,
    ShortcutSection,
    RateSection,
    InfoSection,
  },
  props: {
    closeSettingsModal: {
      type: Function,
    },
    currentQualityIndex: {
      type: Function,
    },
    currentRateIndex: {
      type: Function,
    },
    player: {
      type: Object,
    },
    videoRef: {
      type: Object,
    },
    isLive:{
      type: Boolean
    },
  },
  data() {
    return {
      isKeysShow: true,
    };
  },
  methods: {
    reseizeShortcuts() {
      const isMobileDevice = window.matchMedia("(pointer:coarse)").matches;
      const shortcuts = document.querySelector(".shortcutTitle");
      if (shortcuts) {
        if (isMobileDevice) {
          shortcuts.style.display = "none";
        } else {
          shortcuts.style.display = "";
        }
      }
    },
    handleKeysDisplay() {
      this.isKeysShow = !this.isKeysShow;
    },
  }, 
  computed: {
    ...mapGetters(["getSkinInfos"]),

  },
  mounted() {
    this.reseizeShortcuts();
  },
});
</script>

<style>
.Accordion {
  overflow: hidden;
  height: 100%;
  top: 0%;
  position: absolute;
  width: inherit;
  padding-right: 6px;
  width: 100%;
}

.btnAction {
  color: var(--vm-color-three);
  font-size: 10px;
}

.vjs-settings-menu {
  width: 100%;
  max-width: none;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  color: var(--vm-color-three-08);
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s, visibility 0.5s;
}

.vjs-settings-menu .vjs-menu-content {
  display: block !important;
  border-bottom: 1px solid var(--vm-color-three-04);
  margin-bottom: 1em;
  padding-bottom: 1em;
  padding-left: 2em;
}

.modalLayout {
  height: 100%;
  width: 100%;
}

.vjs-menu-title {
  text-align: left;
  font-size: 1em;
  text-transform: none;
  padding: 0;
  line-height: 2em;
  margin: 0 0 0.3em;
  font-weight: 700;
  cursor: default;
}

.keys-hidden {
  opacity: 1;
  height: auto;
  transition: all 0.6s ease-out;
}

.keys-shown {
  transition: all 0.6s ease-out;
  opacity: 0;
  height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  margin: 0 !important;
  visibility: hidden;
}
</style>
